<a #wrappedContent (click)="copyContent()" class="add-hover text-muted">
    <ng-content></ng-content>
    <img src="/assets/images/app/icons/copy.svg" alt="copy" matTooltip="copy to clipboard"/>
</a>
